import { createSlice } from "@reduxjs/toolkit";
import { update } from "lodash";
import moment from "moment";
// import { updateSelectedClinic } from "../clinic/clinicSlice";



const initialState = {
    report: [],
    error: null,
    aptReport: [],
    revenueReport: [],
    carePerformanceReport: [],
    selectedPatientLevel: {},
    selectedOrg: { organizationId: null, organizationName: '' },
    selectedClinic: { clinicId: null, clinicName: '' },
    month: {
        id: moment().format('M'),
        value: moment().format('MMMM'),
    },

    yearDropdown: {
        id: moment().format('YYYY'),
        value: moment().format('YYYY'),
    }
}

const reportSlice = createSlice({
    name: 'report',
    initialState,
    reducers: {
        updateConsentReport: (state, action) => {
            state.report = action.payload || []

        },
        updateAptReport: (state, action) => {
            state.aptReport = action.payload || []

        },
        updateRevenueReport: (state, action) => {
            state.revenueReport = action.payload || []

        },
        updateCarePerformanceReport: (state, action) => {
            state.carePerformanceReport = action.payload || []

        },
        updateMonth: (state, action) => {
            state.month = action.payload || {}
        },
        updateYear: (state, action) => {
            state.yearDropdown = action.payload || {}
        },
        updatedSelectedPatient: (state, action) => {
            state.selectedPatientLevel = action.payload || {}
        },
        updateSelectedOrg: (state, action) => {
            state.selectedOrg = action.payload || {}
        },
        updateSelectedClinic: (state, action) => {
            state.selectedClinic = action.payload || {}
        }
    },
})

export const {
    updateConsentReport,
    updateAptReport,
    updateRevenueReport,
    updateCarePerformanceReport,
    updateMonth,
    updateYear,
    updatedSelectedPatient,
    updateSelectedClinic,
    updateSelectedOrg
} = reportSlice.actions

export default reportSlice.reducer;